<template>
  <div class="dashboard-container">
    <ErrorPage v-if="error" :discord="discord" />
    <!-- <TOSAgreement 
      v-if="dataLoaded && !hasSignedTOS"
      :discord="discord"
      @esign="handleEsign"
    /> -->
    <div class="dashboard-components" v-if="hasSignedTOS">
      <User v-if="dataLoaded" :discord="discord" :email="email" />
      <Subscription v-if="dataLoaded" :user="user" :discord="discord" />
      <div class="header-wrapper mt-2">
        <b-button @click="breadalerts_control" variant="outline-primary" v-if="is_admin">{{ breadalert_cnrt }}</b-button>
      </div>
      <!-- <div class="header-wrapper mt-2">
        <b-button
          v-b-modal.cancel_modal
          variant="danger"
          v-if="is_admin"
          >Delete Scanner Data</b-button
        >
      </div> -->
      <div class="header-wrapper mt-2">
        <b-button @click="open_scanner" variant="outline-primary" v-if="is_active && dataLoaded">Open Scanner</b-button>
      </div>
      <!-- <div class="header-wrapper mt-2">
        <b-button
          @click="get_token"
          variant="outline-primary"
          v-if="is_active && dataLoaded && is_breadalerts_visible"
          >Open Breadalerts</b-button
        >
      </div> -->
      <div class="header-wrapper mt-2">
        <b-button @click="open_trade_page" variant="outline-primary" v-if="isActive">Open Journal</b-button>
      </div>

      <div class="header-wrapper mt-2">
        <b-button @click="open_course" variant="outline-primary" v-if="is_member">Open Course</b-button>
      </div>

      <div class="header-wrapper mt-2">
        <b-button @click="open_blog" variant="outline-primary" v-if="isActive">CHECK OUT THE BLOG</b-button>
      </div>

      <StripePayment v-if="dataLoaded && processor === 'stripe'" :user="user" :discord="discord" />
      <PaypalPayment v-if="dataLoaded && processor === 'paypal'" :user="user" :discord="discord"
        @updateStatus="updateStatus" />
      <div class="payment-view"></div>

      <b-modal id="cancel_modal" ref="cancel_modals" hide-footer centered title="Delete Scanner Data">
        <p class="my-4">Are you sure, want to delete data ?</p>
        <div>
          <div align-h="center">
            <b-button class="mr-2" variant="danger" @click="delete_scanner_data">Sure</b-button>
            <b-button class="mr-2" variant="outline-primary" @click="$bvModal.hide('cancel_modal')">Cancel</b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import db from "../../database/index";
const collection = db.collection("users");
const config = db.collection("config");
const trend_data = db.collection("trend_data");

import StripePayment from "@/components/StripePayment";
import PaypalPayment from "@/components/PaypalPayment";
import Subscription from "@/components/Subscription";
import User from "@/components/User";
import ErrorPage from "@/components/ErrorPage";

export default {
  name: "Dashboard",
  metaInfo: {
    title: "Market Moves - Dashboard",
    titleTemplate: "Dashboard",
  },
  components: {
    StripePayment,
    PaypalPayment,
    Subscription,
    User,
    ErrorPage,
  },
  data() {
    return {
      discord: {},
      is_active: false,
      user: {},
      email: "",
      dataLoaded: false,
      processor: "",
      hasSignedTOS: true,
      error: false,
      session_token: null,
      access_token: "hHwC3ZenYPNeBWV3I0zyRCJq6E07ve",
      refresh_token: "hHwC3ZenYPNeBWV3I0zyRCJq6E07ve",
      isActive: false,
      is_breadalerts_visible: true,
      breadalert_cnrt: "Turn off",
      is_admin: false,
      is_member: false,
    };
  },
  async mounted() {
    // Check is user is authorized to use dashboard
    if (!this.$cookies.get("session_token")) this.$router.push({ path: "/" });

    // Retrieve user data
    await this.fetchDiscordData();
    await this.fetchUserData();

    // Check if user data exists after fetching
    if (Object.keys(this.user).length === 0) this.error = true;

    if (!this.error) this.dataLoaded = true;

    console.log("User Data ", this.user);
    if (!this.user.status) this.user.isActive = false;

    if (this.user.type === "admin") this.is_admin = true;

    if (this.user.type === "admin" || this.user.type === "member") {
      this.is_member = true;
    }
  },
  methods: {
    async fetchDiscordData() {
      const token = {
        session_token: this.$cookies.get("session_token"),
      };
      return axios
        .post(
          "https://us-central1-market-moves.cloudfunctions.net/app/api/verify",
          token
        )
        .then((user) => {
          this.discord = user.data;
        })
        .catch((err) => console.error(err));
    },
    async fetchUserData() {
      return collection
        .where("discordId", "==", this.discord.id)
        .get()
        .then((snap) =>
          snap.forEach((doc) => {
            if (doc.exists) {
              this.user = doc.data();
              this.email = doc.id;
              this.processor = this.user.processor;
              console.log(this.user);
              if (this.user.status === "active" || this.user.type === "trial") {
                this.is_active = true;
              }
              if (this.user.status === "active" || this.user.type === "trial") {
                this.isActive = true;
              }
            }
          })
        )
        .then(() => {
          config
            .doc("options")
            .get()
            .then((doc) => {
              if (doc.exists) {
                let data = doc.data();
                this.is_breadalerts_visible = data["is_breadalerts_visible"];
                if (this.is_breadalerts_visible) {
                  this.breadalert_cnrt = "Turn off";
                } else {
                  this.breadalert_cnrt = "Turn on";
                }
              }
            });
        })
        .catch((err) => console.error(err));
    },
    async updateStatus() {
      await this.fetchUserData();
    },
    handleEsign() {
      this.hasSignedTOS = true;
    },
    get_token() {
      const token = {
        session_token: this.$cookies.get("session_token"),
      };
      axios
        .post(
          "https://api.breadalerts.com/api/authentication/generate_mm_token/",
          token
        )
        .then((response) => {
          let data = response.data;
          let access_token = data["access_token"];
          let refresh_token = data["refresh_token"];

          window.location = `https://breadalerts.com/marketmove?access_token=${access_token}&refresh_token=${refresh_token}`;

          // window.open(
          //   `https://breadalerts.com/marketmove?access_token=${access_token}&refresh_token=${refresh_token}`
          // );

          // this.$router.absUrl({ path:  })
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            // console.log(error.response.headers);
            // alert(error.response.data['message'])
          }
          window.location = `https://breadalerts.com/marketmove?access_token=${this.access_token}&refresh_token=${this.refresh_token}`;
        });
    },
    open_trade_page() {
      this.$router.push({ path: "/journal/" + this.discord.id });
    },
    open_scanner() {
      this.$router.push({ path: "/scanner" });
    },
    open_blog() {
      window.location = "https://tradewithmarketmoves.com/";
    },
    breadalerts_control() {
      if (this.is_breadalerts_visible) {
        this.is_breadalerts_visible = false;
        config
          .doc("options")
          .set({ is_breadalerts_visible: this.is_breadalerts_visible });
      } else {
        this.is_breadalerts_visible = true;
        config
          .doc("options")
          .set({ is_breadalerts_visible: this.is_breadalerts_visible });
      }
    },
    open_course() {
      if (!Object.values(this.user).includes('num_month')) {
        this.user["num_month"] = 1;
        collection
          .doc(this.email)
          .update({
            num_month: 1,
          })
          .then(() => {
            this.$router.push({
              name: "Course",
              params: {
                user_data: this.user,
              },
            });
          });
      } else {
        console.log('sent data')
        this.$router.push({
          name: "Course",
          params: {
            user_data: this.user,
          },
        });
      }
    },
    delete_scanner_data() {
      trend_data.doc("symbol_data").set({});
      this.$refs["cancel_modals"].hide();
    },
  },
};
</script>

<style></style>